// @generated by protoc-gen-connect-es v1.3.0
// @generated from file proctoring/v1/incidents.proto (package proctoring.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { IncidentServiceGetConfigurationRequest, IncidentServiceGetConfigurationResponse, IncidentServiceGetRequest, IncidentServiceGetResponse, IncidentServiceOverrideSeverityRequest, IncidentServiceOverrideSeverityResponse, IncidentServiceUpdateConfigurationRequest, IncidentServiceUpdateConfigurationResponse } from "./incidents_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service proctoring.v1.IncidentService
 */
export const IncidentService = {
  typeName: "proctoring.v1.IncidentService",
  methods: {
    /**
     * @generated from rpc proctoring.v1.IncidentService.Get
     */
    get: {
      name: "Get",
      I: IncidentServiceGetRequest,
      O: IncidentServiceGetResponse,
      kind: MethodKind.ServerStreaming,
    },
    /**
     * @generated from rpc proctoring.v1.IncidentService.OverrideSeverity
     */
    overrideSeverity: {
      name: "OverrideSeverity",
      I: IncidentServiceOverrideSeverityRequest,
      O: IncidentServiceOverrideSeverityResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc proctoring.v1.IncidentService.UpdateConfiguration
     */
    updateConfiguration: {
      name: "UpdateConfiguration",
      I: IncidentServiceUpdateConfigurationRequest,
      O: IncidentServiceUpdateConfigurationResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc proctoring.v1.IncidentService.GetConfiguration
     */
    getConfiguration: {
      name: "GetConfiguration",
      I: IncidentServiceGetConfigurationRequest,
      O: IncidentServiceGetConfigurationResponse,
      kind: MethodKind.Unary,
    },
  }
};

